import React from 'react';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';

export const JobTitle = () => {
  const options = [
    { label: 'Administrative staff', value: 'administrativeStaff' },
    { label: 'Support staff', value: 'supportStaff' },
    { label: 'Clinician', value: 'clinician' },
    { label: 'Physician', value: 'physician' },
  ];

  return (
    <React.Fragment>
      <SelectInput
        id="attestation-job-title"
        model="attestation.jobTitle"
        label="Job title"
        options={options}
        data-testid="attestation-submitter-full-name"
        isSearchable
        isClearable
        validators={{
          required: 'Please select one.',
        }}
      />
    </React.Fragment>
  );
};

JobTitle.propTypes = {};

JobTitle.defaultProps = {};
